export enum ParallaxSizeEnum {
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large',
  FULL_HEIGHT = 'full-height',
  CUSTOM = 'custom'
}